"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StringElementNotFoundError = void 0;
class StringElementNotFoundError extends Error {
    constructor(stringElement) {
        super(`StringElement ${stringElement.getParsedString()} with Nesting Index ${stringElement.getNestingIndex()} does not exist in the collection.`);
    }
}
exports.StringElementNotFoundError = StringElementNotFoundError;
//# sourceMappingURL=StringElementNotFoundError.js.map